export type MfaFactor = {
  id: string;
  factor_type: string;
  status: string;
};

/** Há pelo menos um fator TOTP com status "verified". */
export function hasVerifiedTotp(factors: MfaFactor[]): boolean {
  return factors.some(
    (f) => f.factor_type === "totp" && f.status === "verified"
  );
}

/** Id do primeiro fator TOTP verificado, ou null se não houver. */
export function getVerifiedTotpFactorId(factors: MfaFactor[]): string | null {
  const f = factors.find(
    (x) => x.factor_type === "totp" && x.status === "verified"
  );
  return f ? f.id : null;
}

/**
 * Ids de todos os fatores TOTP ainda não verificados.
 *
 * `status !== "verified"`, e não `=== "unverified"`: o GoTrue tem outros
 * status além desses dois, e o que importa aqui é "não está ativo". Um fator
 * assim é o que sobra quando o cliente abandona a ativação — e é o que faz o
 * enroll seguinte falhar com 'friendly name "" already exists', porque o
 * enroll sem friendlyName grava `''` e `'' == ''` bate.
 */
export function getUnverifiedTotpFactorIds(factors: MfaFactor[]): string[] {
  return factors
    .filter((f) => f.factor_type === "totp" && f.status !== "verified")
    .map((f) => f.id);
}
